<label
    #label
    [ngClass]="{ 'left-align': leftAlignLabel }"
    [attr.tabindex]="isDisabled ? '' : '0'"
    (keypress)="keyPress($event)"
>
    <input #input type="checkbox" [ngModel]="checked" [disabled]="isDisabled" (ngModelChange)="onModelChange($event)" />
    <div>
        <app-icon *ngIf="checked" name="check" type="solid" size="s1_75" />
    </div>
    <!-- <div>
        <span class="material-symbols-rounded" aria-label="hidden">check_box</span>
    </div> -->
    <span *ngIf="text">{{ text }}</span>
</label>
